"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var defaultStyles = {
  external: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.75)',
    zIndex: 99
  },
  internal: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    textAlign: 'center'
  }
};
var defaultSize = 80;

var LoadingIndicator = function LoadingIndicator(props) {
  var stylesProp = props.styles,
      sizeProp = props.size,
      message = props.message,
      otherProps = _objectWithoutProperties(props, ["styles", "size", "message"]);

  var styles = defaultStyles || stylesProp;
  var size = defaultSize || sizeProp;
  return _react.default.createElement("div", {
    style: styles.external
  }, _react.default.createElement("div", {
    style: styles.internal
  }, _react.default.createElement(_CircularProgress.default, _extends({
    size: size
  }, otherProps)), _react.default.createElement("br", null), _react.default.createElement("br", null), _react.default.createElement("div", null, message)));
};

LoadingIndicator.propTypes = {
  message: _propTypes.default.string,
  styles: _propTypes.default.object,
  size: _propTypes.default.number
};
var _default = LoadingIndicator;
exports.default = _default;